/*
 * @Author: princemwang
 * @Date: 2022-06-22 14:59:45
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-07-12 11:55:01
 */
import { Layout } from '@tencent/tea-component';
import HeaderCom from '@/components/header/Header';
import { Outlet } from 'react-router-dom';
import { createIosFullScreen } from '@/globalState';

const { Header } = Layout;

const Home = () => {
  const [state] = createIosFullScreen();
  return (
    <>
      <Layout>
        <Header style={{ display: state ? 'none' : 'block' }}>
          <HeaderCom></HeaderCom>
        </Header>
        <Outlet></Outlet>
      </Layout>
      <div className={state ? 'swiper-parent' : ''}></div>
    </>
  );
};
export default Home;
